import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dataService } from '../services/data';

export function useAcknowledge() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ alertId, note }: { alertId: string; note?: string }) =>
      dataService.acknowledgeAlert(alertId, note),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
      queryClient.invalidateQueries({ queryKey: ['alerts', variables.alertId] });
      queryClient.invalidateQueries({ queryKey: ['alertStats'] });
    },
  });
}

export function useResolve() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (alertId: string) => dataService.resolveAlert(alertId),
    onSuccess: (_, alertId) => {
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
      queryClient.invalidateQueries({ queryKey: ['alerts', alertId] });
      queryClient.invalidateQueries({ queryKey: ['alertStats'] });
    },
  });
}
